import { supabase } from '../supabaseClient';
export const phaseStaffingEnabled = () => process.env.REACT_APP_PHASE_STAFFING === 'true';
// Admin planning only: never used by Crew Portal or legacy delivery routing.
export const adminPhaseReviewEnabled = () => process.env.REACT_APP_PHASE_ADMIN_REVIEW === 'true';
export const adminPhaseDraftEditingEnabled = () => process.env.REACT_APP_PHASE_ADMIN_DRAFT_EDIT === 'true';
export async function phaseRpc(name: string, args: Record<string, unknown> = {}) { const { data, error } = await supabase.rpc(name, args); if (error)
    throw Error(error.message || 'Staffing operation failed'); return data; }
export const readPhaseWorkspace = (id: string) => phaseRpc('admin_phase_workspace', { p_lead: id });
export async function phaseCommand(id: string, revision: number, action: string, data: any, requestId: string) { return phaseRpc('admin_phase_command', { p_lead: id, p_expected: revision, p_action: action, p_data: data, p_request: requestId }); }
// The same guarded bridge is used by the existing Make/GHL call sites. A lost
// response is UNCERTAIN and blocks cutover; it is never blindly retried here.
export async function legacyStaffingDelivery<T>(shiftId: string, send: () => Promise<T>): Promise<T> {
    if (process.env.REACT_APP_OUTBOUND_DISABLED === 'true')
        throw Error('Outbound crew delivery is disabled in this development environment');
    if (!phaseStaffingEnabled())
        return send();
    const permit = await phaseRpc('legacy_staffing_delivery', { p_shift: shiftId, p_action: 'BEGIN' });
    try {
        const result = await send();
        await phaseRpc('legacy_staffing_delivery', { p_shift: shiftId, p_action: 'CLOSE', p_permit: permit.permit, p_outcome: 'SENT' });
        return result;
    }
    catch (error) {
        await phaseRpc('legacy_staffing_delivery', { p_shift: shiftId, p_action: 'CLOSE', p_permit: permit.permit, p_outcome: 'UNCERTAIN' }).catch(() => undefined);
        throw error;
    }
}
